import type { GetAllReportConfigurationsResponseType } from 'src/api/generated/touring/types';
import { mapReportConfigurationType } from './helpers';
import type { GetAllReportConfigurationsType } from './types';

export const mapGetAllReportConfigurationsResponseType = (
  api: GetAllReportConfigurationsResponseType
): GetAllReportConfigurationsType => ({
  results: api.data.map(mapReportConfigurationType),
});
